import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/mrwork.webp';
import screenshot_target from '../../../images/letterfunnel/meesvanvelzen.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Mees van Velzen"
      firstname="Mees"
      companyname="MrWork"
      competition="HireLab.io en SmartDreamers"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/meesvanvelzen.js